import { render, staticRenderFns } from "./Stays.vue?vue&type=template&id=80c1af1e&"
import script from "./Stays.vue?vue&type=script&lang=js&"
export * from "./Stays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports